"use client";

import { MENU_BADGE_BASE_CLASS } from "@/lib/menus/menuFreshness";
import {
  formatMenuSourceLabel,
  getMenuSource,
  sourceBadgeClassName,
} from "@/lib/menus/menuSource";
import { useLanguage } from "@/lib/useLanguage";

type Props = {
  publishChannel?: string | null;
  viewportSource?: string | null;
  capturedByUser?: string | null;
  isRestaurantClaimed?: boolean;
  className?: string;
};

export function MenuSourceBadge({
  publishChannel,
  viewportSource,
  capturedByUser,
  isRestaurantClaimed,
  className = "",
}: Props) {
  const { t } = useLanguage();
  const source = getMenuSource({
    publishChannel,
    viewportSource,
    capturedByUser,
    isRestaurantClaimed,
  });
  if (!source) return null;

  const strings = t.menuSource;
  const label = formatMenuSourceLabel(source.kind, {
    community: strings?.community ?? "Subido por usuario",
    venue: strings?.venue ?? "Verificado por restaurante",
    staff: strings?.staff ?? "Equipo MenúHunter",
  });

  return (
    <span
      className={`${MENU_BADGE_BASE_CLASS} ${sourceBadgeClassName(source.kind)} ${className}`}
    >
      {label}
    </span>
  );
}
